/*
 *
 * StructurePhoneInput
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 03-Mar-2025
 */

import StructurePhoneInput from './StructurePhoneInput'

export default StructurePhoneInput
